import { useMutation } from '@tanstack/react-query';

import { connect } from 'getstream';
import { getRandomColor } from 'sdk/utils/randomColor';
import { supabase, streamApi } from '../api';
import { PostDataType, PostAssetType } from '../types';

export const createPost = async (
  data: PostDataType,
  assets: PostAssetType[],
  playlist: number[],
  fileUrl: string,
  hashtags: string[],
  duration?: any,
  series?: number[],

) => {
  const { data: userData } = await supabase.auth.getSession();

  const { data: postData, error: supaBaseError } = await supabase
    .from('posts')
    .insert({
      ...data,
      video_link: fileUrl,
      creator_user_id: userData.session?.user.id,
      duration,
    })
    .select()
    .single();

  if (supaBaseError) {
    throw new Error(supaBaseError.message);
  }

  // notification
  try {
    const userId = userData.session?.user.id;
    const REACT_APP_STREAM_API_KEY: string = process.env.REACT_APP_STREAM_API_KEY || '';
    const REACT_APP_STREAM_APP_ID: string = process.env.REACT_APP_STREAM_APP_ID || '';

    const { data: profile } = await supabase
      .from('user_profiles')
      .select(
        `
        *,
        expertProfile:salons_profile (*),
        privacy:profile_privacy_activity (id, activity, enabled)
      `,
      )
      .eq('id', userId)
      .single();

    const result = await streamApi.post('/getToken', {
      id: userId || 'anonymous',
    });

    const client = connect(
      REACT_APP_STREAM_API_KEY,
      result.token,
      REACT_APP_STREAM_APP_ID,
    );

    const userFeed = await client.feed('user', userId);

    const activity = {
      message: 'Added new post',
      verb: 'post',
      object: `post:${postData?.id}`,
      user: profile,
      video_link: fileUrl,
      foreign_id: postData?.id,
    }; // @ts-ignore
    await userFeed.addActivity(activity);
  } catch (error) {
    return error
  }

  if (assets.length) {
    const { error: assetError } = await supabase
      .from('posts_assets')
      .insert(
        assets.map((v) => ({
          post_id: postData.id,
          asset_id: v.id,
          price_time_posting: v.price,
        })),
      )
      .select();

    if (assetError) {
      throw new Error(assetError.message);
    }
  }

  if (hashtags.length) {
    console.log(hashtags);

    await supabase
      .from('hashtags')
      .upsert(hashtags.map((h) => ({
        color: getRandomColor(), // @ts-ignore
        label: h,
      })), {
        onConflict: 'label',
      })

    const { data: hashtagsData } = await supabase
      .from('hashtags')
      .select('*')
      .in('label', hashtags)

    await supabase
      .from('hashtags_posts')
      .insert(
        hashtagsData?.map((v) => ({
          hashtag_id: v.id,
          post_id: postData.id,
        })),
      )
      .select();
  }
  if (playlist?.length) {
    const { error: playlistError } = await supabase
      .from('posts_playlists')
      .insert(playlist.filter((p) => p).map((p) => ({
        post_id: postData.id, // @ts-ignore
        playlist_id: p.id,
      })))
      .select();

    if (playlistError) {
      throw new Error(playlistError.message);
    }
  }
  if (series?.length) {
    const { error: seriesError } = await supabase
      .from('post_series')
      .insert(
        series.map((p) => ({
          post_id: postData.id, // @ts-ignore
          series_id: p,
        })),
      )
      .select();

    if (seriesError) {
      throw new Error(seriesError.message);
    }
  }

  return postData;
};

export default function useCreatePostWithOutUpload(
  data: PostDataType,
  assets: PostAssetType[],
  playlist: number[],
  fileUrl: string,
  hashtags: string[],
  duration?: any,
  series?: number[],

) {
  return useMutation(() => createPost(
    data,
    assets,
    playlist,
    fileUrl,
    hashtags,
    duration,
    series,

  ), {
    onSuccess: async (res) => res,
    onError: (err) => err,
  });
}
